import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'ship and storage near me page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship and storage near me page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Find <span>Affordable</span><span>Ship and Storage Services Near You</span>',
  description:
    'Discover reliable ship and storage near me solutions tailored to your needs. With flexible storage options and affordable shipping, we make storing and shipping stress-free.',
  image: {
    url: '/images/v2/pages/landing-pages/ship-and-storage-near-me/hero-image.jpg',
    alt: 'Find Affordable Ship and Storage Services Near You'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Ship and Storage Services' }
}

export const ourProcessSectionContent = {
  title: 'How We Provide Affordable Ship and Storage Services',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/ship-and-storage-near-me/how-we-provide-affordable-ship-and-storage-services.png',
    alt: 'How We Provide Affordable Ship and Storage Services'
  },

  articles: [
    {
      id: 1,
      title: 'Seamless Booking Process',
      description:
        'Book your shipping or storage services easily online or by phone. We provide a user-friendly platform to streamline your experience.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/seamless-booking-process.png',
        alt: 'Seamless Booking Process'
      }
    },
    {
      id: 2,
      title: 'Efficient Pickup and Drop-off',
      description:
        'Whether you need door-to-door pickup or prefer dropping off items at one of our partner locations, we make it convenient for you.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/efficient-pickup-and-drop-off.png',
        alt: 'Efficient Pickup and Drop-off'
      }
    },
    {
      id: 3,
      title: 'Transparent Pricing',
      description:
        'Our competitive pricing ensures you get top-quality services without hidden fees, making ship and storage near me affordable for everyone.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/transparent-pricing.png',
        alt: 'Transparent Pricing'
      }
    }
  ]
}

export const fastShippingSectionContent = {
  id: 1,
  title: 'Fast Shipping and Storage Services',
  description:
    'Get dependable ship and storage near me solutions with quick turnaround times. From same-day shipping to long-term storage options, we ensure your items are secure, accessible, and delivered when you need them.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/fast-shipping-and-storage-services.jpg',
    alt: 'Fast Shipping and Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Ship and Storage Services',

  cards: [
    {
      id: 1,
      title: 'Convenient Accessibility',
      description:
        'We partner with over 25,000 locations worldwide, offering seamless access to our storage and shipping services.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/convenient-accessibility.png',
        alt: 'Convenient Accessibility'
      }
    },
    {
      id: 2,
      title: 'Flexible Plans',
      description: 'Choose between short-term or long-term storage solutions based on your personal or business needs.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/flexible-pans.png',
        alt: 'Flexible Plans'
      }
    },
    {
      id: 3,
      title: 'Cost-Effective Solutions',
      description:
        'Save money with competitive pricing, free insurance, and special discounts for students and bulk storage users.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/cost-effective-solutions.png',
        alt: 'Cost-Effective Solutions'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Ship and Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'College Students',
          description:
            'We offer affordable and convenient shipping and storage solutions for students. Whether you’re heading home for the summer or studying abroad, store your dorm essentials with ease.'
        },
        {
          id: 2,
          title: 'Small Businesses',
          description:
            'Secure and flexible storage options for inventory, documents, and e-commerce needs. Our shipping services ensure your business operations run smoothly and efficiently.'
        },
        {
          id: 3,
          title: 'Travelers',
          description:
            'Hassle-free luggage storage and shipping solutions for domestic and international trips. Travel light and stress-free, knowing your belongings are safe and secure.'
        },
        {
          id: 4,
          title: 'Homeowners',
          description:
            'Perfect for decluttering, renovating, or moving to a new home. Store your belongings safely for as long as you need with our affordable residential storage plans.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/who-should-choose-us-for-ship-and-storage-services.jpg',
        alt: 'Who Should Choose Us for Ship and Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description: 'Secure storage tailored for inventory, trade show materials, and office equipment.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Convenient and temporary storage options for a hassle-free relocation process..',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Reliable and safe shipping for luggage, boxes, and personal belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Luggage & Box Shipping' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners during renovations, moves, or extended vacations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Ship and Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/ship-and-storage-near-me/why-choose-shipandstorage-for-ship-and-storage-services.jpg',
    alt: 'Why Choose ShipAndStorage for Ship and Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Global Shipping Partners',
      description:
        'We work with trusted carriers like FedEx, DHL, and UPS to ensure reliable, on-time deliveries to over 220 countries and territories worldwide.'
    },
    {
      id: 2,
      title: 'Reliable Customer Support',
      description:
        'Our dedicated team is available to assist you at every step of your shipping and storage journey, ensuring a smooth and stress-free experience.'
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description:
        'Choose from tailored short-term or long-term storage options designed to meet your unique requirements. Store anything from a single item to bulk belongings effortlessly.'
    },
    {
      id: 4,
      title: 'Insurance Coverage',
      description:
        'Enjoy up to $250 of free insurance coverage to protect your belongings during shipping or storage, providing added security and peace of mind.'
    },
    {
      id: 5,
      title: 'Competitive Rates',
      description:
        'We offer affordable pricing for both shipping and storage services, ensuring you get the best value for your money without compromising quality or reliability.'
    },
    {
      id: 6,
      title: 'Extensive Network',
      description:
        'With over 25,000 locations across the globe, we make it easy to find reliable ship and storage services near you, no matter where you are.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Affordable Ship and Storage Solutions Near You',
  description:
    'Find affordable and secure ship and storage services near you. Fast, reliable solutions to store and ship your belongings efficiently.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-and-storage-near-me/find-affordable-ship-and-storage-solutions-near-you.png',
    alt: 'Find Affordable Ship and Storage Solutions Near You'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const ourPartnersSectionContent = {
  description:
    'At ShipAndStorage, we partner with leading global carriers like FedEx, DHL, and UPS to deliver exceptional shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Founded in 1971 by Frederick W. Smith, FedEx began with just 186 packages and has grown into a global shipping leader. Today, FedEx operates a fleet of 696 aircraft and 215,000 vehicles, handling 16 million shipments daily across more than 220 countries and territories. With a workforce of over 550,000 and 5,000 locations worldwide, FedEx is committed to reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided.For more information, <a href='https://www.fedex.com/en-us/home.html' target='_blank'>visit FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a vital division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a logistics leader, DHL handles over 1.8 billion parcels annually. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a significant role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, <a href='https://www.fedex.com/en-us/home.html' target='_blank'>visit DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Originally founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS is one of the largest shipping companies in the world, delivering 25 million packages daily. With over 500,000 employees globally, UPS serves more than 220 countries and territories, providing unmatched global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For more information, <a href='https://www.fedex.com/en-us/home.html' target='_blank'>visit UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
